var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-highlighted-button",class:{
    'admin-highlighted-button--disabled': _vm.disabled,
  }},[_c('div',[_vm._v(_vm._s(_vm.text))]),_c('md-icon',[_vm._v("navigate_next")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }